import Vue from 'vue'
import Vuex from 'vuex'
import http, { configureAuth } from '../services/http'

Vue.use(Vuex)
const STORAGE_KEY = 'badclams.session'
function readSession () {
  for (const storage of [sessionStorage, localStorage]) {
    try {
      const value = JSON.parse(storage.getItem(STORAGE_KEY) || 'null')
      if (value && typeof value.token === 'string' && Date.parse(value.expiresAt) > Date.now()) return value
      storage.removeItem(STORAGE_KEY)
    } catch (_) { /* An invalid session is discarded. */ }
  }
  return { token: '', user: null, expiresAt: '' }
}
function clearStorage () {
  for (const storage of [sessionStorage, localStorage]) {
    try { storage.removeItem(STORAGE_KEY) } catch (_) { /* Storage can be disabled. */ }
  }
}
const initial = readSession()
let validating = null
let brandRequest=0
function preferredCompany(){try{return Number(localStorage.getItem('badclams.brand-company'))||null}catch(_){return null}}
const store = new Vuex.Store({
  state: { ...initial, validated: false, branding: {} },
  getters: {
    authenticated: state => Boolean(state.token) && Date.parse(state.expiresAt) > Date.now(),
    can: state => permission => Boolean(state.user && (state.user.esAdministrador || (state.user.permisos || []).includes(permission)))
  },
  mutations: {
    branding (state,value) { state.branding=value||{}; if(value && value.idEmpresa)try{localStorage.setItem('badclams.brand-company',String(value.idEmpresa))}catch(_){} },
    session (state, value) {
      state.token = value.token; state.user = value.user; state.expiresAt = value.expiresAt
      state.validated = true
      configureAuth(value.token)
    },
    profile (state, user) { state.user = user; state.validated = true },
    clear (state) {
      state.token = ''; state.user = null; state.expiresAt = ''; state.validated = false
      configureAuth(''); clearStorage(); state.branding={}
    }
  },
  actions: {
    async loadBrand ({state,commit}, {anonymous=false,idEmpresa=null}={}) {
      const request=++brandRequest
      const ids=state.user && state.user.idsEmpresa || []
      const preferred=idEmpresa||preferredCompany()
      const id=anonymous ? preferred : ids.includes(preferred) ? preferred : ids[0]
      try{const {data}=await http.get(anonymous ? 'Marca/Inicio'+(id ? '?idEmpresa='+id : '') : id ? 'Marca/'+id : 'Marca/Inicio',{anonymous});if(request===brandRequest)commit('branding',data);return data}catch(_){if(request===brandRequest)commit('branding',{});return null}
    },
    async login ({ commit,dispatch }, { username, password, remember }) {
      const { data } = await http.post('Usuarios/Login', { username: username.trim(), password }, { anonymous: true })
      if (!data || !data.token || !data.usuario || !(Date.parse(data.expiraEn) > Date.now())) {
        throw new Error('La respuesta de inicio de sesión no es válida. Inténtalo de nuevo.')
      }
      const value = { token: data.token, user: data.usuario, expiresAt: data.expiraEn }
      clearStorage()
      try { (remember ? localStorage : sessionStorage).setItem(STORAGE_KEY, JSON.stringify(value)) } catch (_) { /* In-memory session still works. */ }
      commit('session', value)
      await dispatch('loadBrand')
      return data
    },
    async validate ({ state, getters, commit }) {
      if (!getters.authenticated) { commit('clear'); return false }
      if (state.validated) return true
      if (!validating) {
        validating = http.get('Usuarios/Perfil').then(({ data }) => { commit('profile', data); return true })
          .catch(error => { if (error.status === 401) commit('clear'); throw error })
          .finally(() => { validating = null })
      }
      return validating
    },
    logout ({ commit }) { commit('clear') }
  }
})
configureAuth(initial.token, () => store.commit('clear'))
export default store
